export const NOTE_CATEGORY_COLORS = [
  'yellow',
  'blue',
  'green',
  'pink',
  'purple',
  'orange',
  'teal',
  'gray',
];

export const NOTE_CATEGORY_COLOR_MAP = {
  yellow: {
    label: 'Yellow',
    background: '#FFF4B8',
    border: '#E8D77A',
    text: '#5F541B',
  },

  blue: {
    label: 'Blue',
    background: '#DDEBFF',
    border: '#B8CDEE',
    text: '#304A73',
  },

  green: {
    label: 'Green',
    background: '#DFF3D8',
    border: '#B9D8AE',
    text: '#355C32',
  },

  pink: {
    label: 'Pink',
    background: '#F9DFE8',
    border: '#E3BBCB',
    text: '#754457',
  },

  purple: {
    label: 'Purple',
    background: '#E9E0F7',
    border: '#CDBDE3',
    text: '#5A4773',
  },

  orange: {
    label: 'Orange',
    background: '#FFE3C2',
    border: '#E8C394',
    text: '#704A22',
  },

  teal: {
    label: 'Teal',
    background: '#D8F0EC',
    border: '#ACD3CC',
    text: '#315F59',
  },

  gray: {
    label: 'Gray',
    background: '#ECEFF3',
    border: '#CDD3DA',
    text: '#4B5563',
  },
};

export const DEFAULT_NOTE_CATEGORY_COLOR = 'yellow';

export function isValidNoteCategoryColor(value) {
  return NOTE_CATEGORY_COLORS.includes(value);
}

export function getNoteCategoryColor(value) {
  return (
    NOTE_CATEGORY_COLOR_MAP[value] ||
    NOTE_CATEGORY_COLOR_MAP[DEFAULT_NOTE_CATEGORY_COLOR]
  );
}
